<ng-container *ngIf="isLoading">
    <div class="row row_skeleton" *ngFor="let _ of [1, 2, 3, 4]">
        <div class="skeleton_container" style="width: 250px;"><app-skeleton height="60" count="1" margin="15"
                borderRadius="10px"></app-skeleton></div>
        <div class="skeleton_container" style="width: 25px;"><app-skeleton height="25" count="1" margin="15"
                borderRadius="50px"></app-skeleton></div>
    </div>
</ng-container>
<div class="no_data fz_l row row_ai_center row_jc_center" [ngClass]="{'color_violet' : typeof dataMissing === 'boolean', 'color_red' : typeof dataMissing === 'string'}" *ngIf="dataMissing">{{typeof dataMissing == 'string' ? dataMissing : 'Напиши первый комментарий'}}</div>
<div class="row comment_group" *ngFor="let note of customerNotes" (contextmenu)="showMessageActionMenu($event, note.id)">
    <div class="comment"><p class="text fz_xs">{{note.text}}</p>
        <div class="comment_info row fz_xxs color_text_gray"><p class="date">{{dateFormatterPipe.transform(note.createdAt, 'yyyy-MM-dd HH:mm:ss')}}</p><p class="edited" *ngIf="dateFormatterPipe.transform(note.updatedAt, 'yyyy-MM-dd HH:mm:ss') > dateFormatterPipe.transform(note.createdAt, 'yyyy-MM-dd HH:mm:ss')">Отредактировано</p><p class="author">{{note.user.firstname}} {{note.user.lastname}}</p></div>
    </div>
    <div class="user"><div class="avatar" style="background-image: url({{note.user.profileImage}});"></div></div>
    <ul *ngIf="activeNoteId === note.id" class="action_menu card fz_xs"
        [ngStyle]="{'top.px': menuPosition.y, 'left.px': menuPosition.x}">
        <li class="item dark_btn row row_ai_center" (click)="editMessage(note)"><span class="material-symbols-outlined fz_m">
            edit_square
        </span>Редактировать</li>
        <li class="item dark_btn row row_ai_center color_red" (click)="deleteMessage(note)"> <span class="material-symbols-outlined fz_m">
            delete
        </span> Удалить</li>
    </ul>
</div>
<!-- <div *ngIf="deletedComment" class="deleted_comment comment">Комментарий удалено</div> -->


